module.exports = "/images/icon_loud02_sp.png?84cf61d64bb524241e3f9c2b06ce544c";